module.exports = __webpack_public_path__ + "static/yuan_ti_pureblood-241a5fcf7fe95925b7dd21c96f6f6032.jpeg";